import React, { PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDynamicImage } from "@hooks";
import { Logo } from "@rentablo/components";

const Container = styled.div`
  display: flex;
  height: 100vh;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: ${({ theme }) => theme.spacing(6, 3)};
  }
`;

const MainColumn = styled.main`
  flex-grow: 1;
`;

const Img = styled.img`
  height: 100vh;
  object-fit: contain;
`;

const ContentContainer = styled.div`
  height: calc(100% - 79px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4)} 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    min-height: calc(100% - 79px);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: ${({ theme }) => theme.spacing(4)};
  }
`;

interface ShowcaseLayoutProps {
  img?: string;
}

export const ShowcaseLayout = (
  props: PropsWithChildren<ShowcaseLayoutProps>
) => {
  const { children, img } = props;
  const { t } = useTranslation();
  const { image } = useDynamicImage(img);

  const isMoreMd = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <Container>
      <MainColumn>
        <ImageContainer>
          <Logo alt={t("components.layouts.showcaseLayout.imageAlt")} />
        </ImageContainer>
        <ContentContainer>{children}</ContentContainer>
      </MainColumn>
      {isMoreMd && image && <Img src={image} />}
    </Container>
  );
};
